// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"c2eaee52","553":"dfba345d","977":"4d424b04"}[chunkId] + ".chunk.js";
};